import { Reveal } from "@/components/Reveal";
import { renderAccent } from "@/components/RichText";

export default function SectionHeading({ overline, title, description, align = "left", dark = false }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-5 ${alignCls}`}>
      {overline && (
        <Reveal y={16}>
          <span
            className={`inline-flex items-center gap-3 font-accent text-xs uppercase tracking-[0.3em] ${
              dark ? "text-gold-light" : "text-gold-dark"
            }`}
          >
            <span className="h-px w-8 bg-gold/60" />
            {overline}
            {align === "center" && <span className="h-px w-8 bg-gold/60" />}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2
          className={`font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl text-balance ${
            dark ? "text-white" : "text-charcoal-900"
          }`}
        >
          {typeof title === "string" ? renderAccent(title, dark ? "italic text-gold-light" : "italic text-gold-dark") : title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p
            className={`max-w-xl text-base leading-relaxed md:text-lg ${
              dark ? "text-white/60" : "text-muted-foreground"
            } ${align === "center" ? "mx-auto" : ""}`}
          >
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
